import React from 'react'

export default function RefoundIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="12" fill="#F87171" fill-opacity="0.1"/>
            <path d="M6 8.66675V12.6667M6 12.6667H10M6 12.6667L8 10.8667C9.09924 9.88085 10.5234 9.33492 12 9.33341C13.5913 9.33341 15.1174 9.96556 16.2426 11.0908C17.3679 12.216 18 13.7421 18 15.3334" stroke="#F87171" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}